export default function isSSR(ssr) {
    return ssr === 'undefined'
}